import { MutationResult } from "@/api/utils/types"
import { useMutation } from "@/api/utils/useQuery"
import { BackofficeRestMutations } from "@/api/backofficeRest/mutations"

interface UpdateFeatureVariables {
  id: number
  enabled: boolean
}

export interface IFeatureMutator {
  update(onSuccessFn?: () => void): MutationResult<UpdateFeatureVariables>
}

export class FeatureMutatorClass implements IFeatureMutator {
  update(onSuccessFn?: () => void): MutationResult<UpdateFeatureVariables> {
    return useMutation({
      ...BackofficeRestMutations.featureFlags.update(),
      serializerFn: ({ id, enabled }) => ({ id, body: { enabled } }),
      onSuccessFn,
    })
  }
}

export const FeatureMutator = new FeatureMutatorClass()
